import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";
import { useUser } from "./useUser";

export const useIsAgent = () => {
  const { user } = useUser();
  const [isAgent, setIsAgent] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      if (!user?.id) {
        setIsAgent(false);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const { data, error } = await supabase
          .from("agent_users")
          .select("user_id")
          .eq("user_id", user.id)
          .maybeSingle();

        if (error) {
          console.error("Error checking agent status:", error);
          setIsAgent(false);
        } else {
          setIsAgent(!!data);
        }
      } catch (error) {
        console.error("Error checking agent status:", error);
        setIsAgent(false);
      } finally {
        setLoading(false);
      }
    };

    check();
  }, [user?.id]);

  return { isAgent, loading };
};
